import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

import {BillingPlanPriceResponse} from '../types';

export type IndividualPricesSuccessResponse = BillingPlanPriceResponse;

export type IndividualPricesErrorResponse = Api.Response.Failure<string>;
type GetIndividualPricesProps = {
    onError: (error: IndividualPricesErrorResponse) => void;
    searchParams?: {[k: string]: number | string};
};

export const useGetIndividualPrices = ({
    onError,
    searchParams,
}: GetIndividualPricesProps): UseQueryResult<
    IndividualPricesSuccessResponse,
    IndividualPricesErrorResponse
> => {
    const locale = useLocale();

    return useQuery(
        ['getIndividualSubscription', searchParams],
        () =>
            request({
                locale,
                url: `/api/billing/plan/price/individual_2/?${new URLSearchParams(toSnakeCase(searchParams)).toString()}`,
            }),
        {
            onError,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    );
};

export default useGetIndividualPrices;
